import React, { useState, useEffect } from 'react'
import '../App.css'
import { useNavigate, useParams } from 'react-router-dom';
import { apiGetLeagueLeaderboard } from '../lib/api/leaderboard';
import ErrorToast from '../components/Toast';

import { io } from "socket.io-client";
const socket = io(process.env.REACT_APP_WEBSOCKET_URL as string);

export default function LeaderboardScreen() {

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!errorMessage) {
      return;
    }
    setTimeout(() => {
      setErrorMessage(null);
    }, 4000);
  }, [errorMessage])

  const navigate = useNavigate();

  // const { eventId } = useParams();

  const [loadingLeaderboard, setLoadingLeaderboard] = useState<boolean>(true);

  const [leaderboard, setLeaderboard] = useState<{
    rank: number;
    name: string;
    lapTimeReduction: number;
  }[]>([]);

  useEffect(() => {
    try {
      // get leaderboard via api
  
      apiGetLeagueLeaderboard().then(leaderboardRes => {

        if (!leaderboardRes) {
          setLeaderboard([]);
          return;
        }

        if (leaderboardRes.length === 0) {
          setLeaderboard([]);
          return;
        }

        setLeaderboard(leaderboardRes.map((leaderboardItem, index) => {
          return {
            rank: index + 1,
            name: leaderboardItem.username,
            lapTimeReduction: leaderboardItem.lapTimeReduction,
          }
        }));

        setLoadingLeaderboard(false);

      }).catch((err) => {
        setLoadingLeaderboard(false);
        if (typeof err === 'string') {
          setErrorMessage(err);
        } else {
          setErrorMessage('Something went wrong');
        }
      });

    }
    catch (err) {
      setLoadingLeaderboard(false);
      if (typeof err === 'string') {
        setErrorMessage(err);
      } else {
        setErrorMessage('Something went wrong');
      }
    }
  }, [])
  
  // Websocket Auto-Refresh

  useEffect(() => {
    // listen for leaderboard updates for this event
    socket.on(`leaderboard-updated`, (data) => {
      // update the leaderboard
      setLeaderboard(data.map((leaderboardItem: any, index: number) => {
        return {
          rank: index + 1,
          name: leaderboardItem.username,
          lapTimeReduction: leaderboardItem.lapTimeReduction,
        }
      }
      ));
    });
  }, [])

  return (
    <>
      <div id="site-wrapper">
        <main className="intro-screen-wrapper">
          <div className="intro-screen-main-container">
            <div className="title-section">
              <img className="logo" src={require('../assets/aws_f1_logo.png')} />
              <h1 className="huge">AWS FastTrack Leaderboard</h1>
            </div>
            {/* Leaderboard */}
            {
              loadingLeaderboard ? (
                <h2>Loading...</h2>
              ) : (
                <table className="leaderboard-table">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Name</th>
                      <th>Lap Time Reduction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      leaderboard.map((leaderboardItem, index) => {
                        return (
                          <tr key={index}>
                            <td>{leaderboardItem.rank}</td>
                            <td>{leaderboardItem.name.toUpperCase()}</td>
                            <td>{ leaderboardItem.lapTimeReduction > 0 ? "-" : "" }{leaderboardItem.lapTimeReduction.toFixed(2)}</td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
              )
            }
            {/* Main Menu Button */}
            <button type="button" className="outline-button" onClick={() => {
              navigate(`/`);
            }}>Main Menu</button>
          </div>
        </main>
      </div>
      <ErrorToast message={errorMessage} />
    </>
  );
}
